<script>
import Select2 from 'vue3-select2-component';
import { ref, toRefs,  watchEffect } from 'vue';
import axios from 'axios';
export default {
    props: {
        marketplacesIds: Array,
        id: String,
        url: String,
    },
    components: {
        Select2,
    },
    setup(props) {
        const { marketplacesIds } = toRefs(props); // Destructure props and make it reactive
        const options = ref([]);
        const selectedOption = ref([]);
        console.log(marketplacesIds);
        // Fetch options from the API, filtered by marketplacesIds
        const fetchOptions = async () => {
            try {
                const response = await axios.get(`${props.url}/marketplaces/ajaxLinkedMarketplaces`);
                options.value = response.data.results.filter(option => !marketplacesIds.value.includes(option.id));
            } catch (error) {
                console.error(error);
            }
        };

        watchEffect(() => {
            fetchOptions();
        });
        return {
            options,
            selectedOption

        };
    },
    data() {
        return {
            showLoading: false,
            form: {
                checked:[],
                percentage:null
            },
            formatedForm:[]
        };
    },
    methods: {
        updateMarketplaces() {
            try {
                axios.post(`${this.url}/api/products/linked_product/attach-new-marketplace/${this.id}`, $('#addlistMarketplaces :input').serialize()).then((res) => {
                    this.$emit("updateMarketplaces", res.data.result.marketplaces);
                });
            } catch (error) {
                console.error(error);
            }
        }
    },
};
</script>

<template>

    <div class="modal fade" tabindex="-1" id="add_marketplaces" rel="">
        <div class="modal-dialog modal-dialog-centered model-lg mw-650px">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('marketplaces') }}</h5>
                    <div>
                      <button type="button" class="btn btn-light mx-2" data-bs-dismiss="modal">{{ $t('cancel') }}</button>

                      <button type="button" class="btn btn-sm bg-app" @click="updateMarketplaces()">
                        {{ $t('save') }}
                      </button>
                    </div>
                    <!--end::Close-->
                </div>

                <div class="modal-body">
                    <div id="addlistMarketplaces">
                        <label for="marketplace" class="form-label">{{ $t('choose_marketplace') }}</label>
                        <Select2  v-model="selectedOption" name="marketplaces[]" :options="options" multiple :settings="{ multiple: true, closeOnSelect: false, dropdownCssClass: 'custom-dropdown-2' }"></Select2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style >
#edit_market .modal-dialog {
    max-width: 80%;
}
</style>
